export const numFormat = (
  num: number | string,
  options: {
    currency?: string;
    decimal?: number;
    locales?: string;
  } = {},
): string => {
  const { currency, decimal = 2, locales = "th-TH" } = options;

  const localeOptions: Intl.NumberFormatOptions = {};

  if (Number.isInteger(decimal)) {
    localeOptions.minimumFractionDigits = decimal;
    localeOptions.maximumFractionDigits = decimal;
  }

  if (currency) {
    localeOptions.currency = currency;
    localeOptions.style = "currency";
  }

  return Number(num).toLocaleString(
    locales,
    localeOptions,
  );
};

export const priceFormat = (num: number | string): string => {
  return numFormat(
    num,
    { currency: "THB", decimal: 0 },
  );
};

export const compactFormat = (number: number) => {
  const compactFormatter = new Intl.NumberFormat("en-US", {
    compactDisplay: "short",
    notation: "compact",
  });
  return compactFormatter.format(number);
};

export const approxNumber = (num: number): number => {
  // Find the number of digits minus one (i.e., the power of 10)
  const digits = Math.floor(Math.log10(num));
  // Compute the nearest power of 10 less than or equal to the number
  const factor = 10 ** digits;
  // Round the number down to the nearest multiple of this factor
  return Math.floor(num / factor) * factor;
};
